/** Keep an available explicit preference; otherwise start with a catalog narrator. */
export function resolvePreviewVoice<T extends { id: string; is_narrator?: boolean }>(voices: readonly T[], preferred = ''): string {
  if (voices.some(voice => voice.id === preferred)) return preferred;
  return voices.find(voice => voice.is_narrator === true)?.id ?? voices[0]?.id ?? '';
}
